<template>
    <div>
        <div class="acitve-items" >
							<div class="active-items-title-read">
								<div class="active-item-title on-show-two">{xdqwd }</div>
								<div class="active-imgs">
									<img v-for="item in 3" src="../../assets/images/activity/pic-logo1@2x.png" alt="">
								</div>
								<div class="active-itme-read">
									<span v-for="(cate,i) in row.cate_list" :key="i">{{cate.name}}</span>
									<span>{{row.views_count}}阅读</span></div>
							</div>
							
						</div>
    </div>
</template>

<style scoped>
    /* 多图 */
	.acitve-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;display: flex;justify-content: space-between;}
	.active-items-title-read{display: flex;justify-content: space-between;flex-direction: column;}
.active-item-title{
		 
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(0,0,0,1); 
	}
	 
	.acitve-item-title{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
	}
	.active-itme-read{ 
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
		margin-top:0.2rem;
	}
    .active-imgs{
		display: flex;
		justify-content:space-between;

	}
	.active-imgs img{
		width: 30%;
		height: auto;
	}
</style>

<script>
    export default {
        name: "NewsItem4",
        components: {
        },
        props: {
			row: {
				type: Object,
				default: {
					title:'',
					cate_list:[],
					pics:[],
					pics_url:[]
				}
			}
        },

        data: function () {
            return {}
        },

        methods: {
            
        },

        filters: {}

    };
</script>




// WEBPACK FOOTER //
// NewsItem4.vue?532f6782